<template>
  <section class="ma-3">
    <section class="d-flex justify-center align-center">
      <!-- <p>VaiVem Livre</p> -->
      <img width="130" src="@/assets/vai-vem/vaivem-icon.svg" />
    </section>
    <v-container>
      <services-list :data="services"></services-list>
    </v-container>
  </section>
</template>

<script>
import ServicesList from '@/components/ServicesList.vue';
import { services } from '@/models/service';

export default {
  metaInfo: {
    title: 'VaiVem - Central de Serviços',
  },
  components: {
    ServicesList,
  },
  data: () => {
    return {
      services: services.filter(service => service.name == 'VaiVem'),
      icon: '',
    };
  },
};
</script>
